import gql from 'graphql-tag';


export const UPDATE = gql(`
mutation($data: ComponentDataSourceInputType!){
    componentDataSourceMutation{
        updateComponentDataSource(data:$data){
           id,          
  dataSourceId,
  componentId,
  fcr
  ucr
  name
  autoSave
  autoLoad
  maxRowsReturned
  applicationId
  applicationVersion
  iapComponentDataSourceFieldConfigurations{
      componentDataSourceId
      dataSourceFieldId
      defaultFilterSearch
      autoUpdate
      defaultValue
      defaultValidation
      defaultFilterSearchOrder
      edit
      add
      editMassive
      import
      fcr
      filterResult
      filterResultOrder
      filterSearch
      filterSearchOrder
      fum
      view
      list
      mandatory
      sortOrder
      idSortType
      dataSourceField{
          tableName
          field
      }
      
  }
  dataSource{
      id,
      name,
      description,
      idDataSourceType
      ,
        iapDataSourceDataBase{
          id
          dataSourceId
          idBaseDatos
          idDataBaseType
          querySelect
          queryFrom
          queryWhere
          queryOrderBy
          queryGroupBy
          queryHaving
          fcr
          ucr
          uum
          fum
        },
        iapDataSourceServices{
          id
          dataSourceId
          idHttpMethodType
          idAuthType
          url
          fcr
          ucr
          uum
          fum         
        },        
       iapDataSourceFields{
     id,
     dataSourceId,
     dataSourceTableAliasId
      tableName,
      field,
      shortDescription,
      description
  }
      iapDataSourceTableAliases{
        tableName,
        tableAlias,
        shortDescription,
        join
      }
  }
        }
    }
}
`);

export const DELETE = gql(`
mutation($componentDataSourceId: Int!){
    componentDataSourceMutation{
        deleteComponentDataSource(componentDataSourceId:$componentDataSourceId)
    }
}
`);


export const ADD = gql(`
mutation($data: ComponentDataSourceInputType!){
    componentDataSourceMutation{
        addComponentDataSource(data:$data){
           id,          
  dataSourceId,
  componentId,
  fcr
  ucr
  name
  autoSave
  autoLoad  
  maxRowsReturned
  applicationId
  applicationVersion
  iapComponentDataSourceFieldConfigurations{
      componentDataSourceId
      dataSourceFieldId
      defaultFilterSearch
      defaultFilterSearchOrder
      autoUpdate
      defaultValue
      defaultValidation
      edit
      add
      editMassive
      import
      fcr
      filterResult
      filterResultOrder
      filterSearch
      filterSearchOrder
      fum
      list
      view
      mandatory
      sortOrder
      idSortType
      dataSourceField{
          tableName
          field
      }
      
  }
  dataSource{
      id,
      name,
      description,
      idDataSourceType   
      ,
        iapDataSourceDataBase{
          id
          dataSourceId
          idBaseDatos
          idDataBaseType
          querySelect
          queryFrom
          queryWhere
          queryOrderBy
          queryGroupBy
          queryHaving
          fcr
          ucr
          uum
          fum
        },
        iapDataSourceServices{
          id
          dataSourceId
          idHttpMethodType
          idAuthType
          url
          fcr
          ucr
          uum
          fum         
        },     
       iapDataSourceFields{
     id,
     dataSourceId,
     dataSourceTableAliasId
      tableName,
      field,
      shortDescription,
      description,
      dataSourceLookUpId
  }
      iapDataSourceTableAliases{
        tableName,
        tableAlias,
        shortDescription,
        join
      }
  }
        }
    }
}
`);



